import { observable, action } from 'mobx';
import { store } from '../store.index';
import { FW_USER_LOGIN_IN_SUCCESS } from 'Store/constants';
import { isMobile, isMacSsoNoIos, isFirefox } from 'Utils/device';
import { isSafari } from 'Utils/browser-info';
import { cookies } from 'Api/index';
import { getIAMToken, IamLogout } from 'Api/fwApi/login';
class loginNewStore {
  @observable isLogin = false;
  // @observable isLogin = true;
  // TODO FOXIT 是否显示sso登录弹框
  @observable isShowIframeSso = false;
  @observable showLoginDlg = false;
  @observable IAMToken =
    window.readerCookies && window.readerCookies.accessToken
      ? window.readerCookies.accessToken
      : '' || (window.cloudCookies && window.cloudCookies.accessToken)
      ? window.cloudCookies.accessToken
      : '';
  @observable IAMSwitchUrl = null;
  @observable isLoginAfterClearCookie = false;

  @action setIsLogin(val) {
    this.isLogin = val;
    if (val) {
      // 1、当用户登录时，判断是否显示过广告，为显示执行广告获取和弹窗
      store.appStore.emitEvent(FW_USER_LOGIN_IN_SUCCESS, true);
      this.isShowIframeSso = false;
      if (!isMobile) {
        store.advertStore.getAdvert();
      }
    }
  }
  @action setIsLoginAfterClearCookie(val) {
    this.isLoginAfterClearCookie = val;
  }
  @action signOut() {
    if (this.IAMToken) {
      this.logout();
      return;
    }
    let logoutHref = `https://webpdfapi.foxitcloud.cn/logout?url=${window.location.origin}${window.location.search}${
      isMacSsoNoIos || isSafari ? '&systemType=mac' : ''
    }`;
    if (store.userNewStore.userData.userId) {
      logoutHref += `&userId=${store.userNewStore.userData.userId}`;
    }
    this.setIsLogin(false);
    store.userNewStore.getUserNewCount = false;
    store.userNewStore.firstLogin = 0;
    store.userNewStore.userToken = '';
    store.userNewStore.setUserInfo(null);
    localStorage.removeItem('token');
    store.common.isShowLoginLoseDialog = false;
    store.common.isLoginLoseDialog = false;
    store.advertStore.setOnceShowAdvert(false);
    cookies.remove('fwShareToken', { path: '/' });
    // let logoutHref = `https://webpdfapi.foxitcloud.cn/logout?url=${window.location.href}&userId=${store.userNewStore.userData.userId}`
    window.location.href = logoutHref;
  }
  @action setIsShowIframeSso(val) {
    this.isShowIframeSso = val;
    if (val) {
      this.jumpLogin();
    }
  }
  @action logout() {
    IamLogout({
      params: {
        userId: store.userNewStore.userData.userId,
      },
    }).then(() => {
      this.setIsLogin(false);
      this.IAMToken = '';
      sessionStorage.removeItem('iamToken');
      store.userNewStore.getUserNewCount = false;
      store.userNewStore.firstLogin = 0;
      store.userNewStore.userToken = '';
      store.userNewStore.setUserInfo(null);
      localStorage.removeItem('token');
      store.common.isShowLoginLoseDialog = false;
      store.common.isLoginLoseDialog = false;
      cookies.remove('iamToken');
      cookies.remove('accessToken');
      cookies.remove('fwShareToken', { path: '/' });
      window.location.href = `https://account.foxitreader.cn/logout.html?redirectUrl=${encodeURIComponent(location.href)}`;
    });
  }
  @action login() {
    this.loginIAM();
    return;
    if (isMobile) {
      window.location.href = `https://webpdfapi.foxitcloud.cn/login_cb?cb=${encodeURIComponent(window.location.href)}${
        isMacSsoNoIos || isSafari ? '&systemType=mac' : ''
      }`;
    } else {
      this.isShowIframeSso = true;
    }
  }
  @action setIAMSwitchUrl(val) {
    this.IAMSwitchUrl = val;
  }

  @action loginIAM() {
    const origin = location.origin;
    const redirectUrl = encodeURIComponent(`${origin}/login${isMobile ? 'Mobile' : ''}.html`);
    const cb = encodeURIComponent(window.location.href);

    // 跳转逻辑
    const accountLoginUrl = `https://account.foxitreader.cn/login?redirectUrl=${redirectUrl}&cb=${cb}`;
    if (isFirefox && !isMobile && location.href.includes('uuid')) {
      window.location.href = accountLoginUrl;
    } else if (isMobile) {
      window.location.href = accountLoginUrl;
    } else {
      this.setIsShowIframeSso(true);
    }
  }
  //TODO FOXIT 关闭sso登录弹框
  @action closeIframeSso(type) {
    this.isShowIframeSso = false;
    if (type === 'handleCancel' && !this.isLogin) {
      !isMobile && store.advertStore.getAdvert();
    }
  }
  @action isShowLoginDlg() {
    if (!this.isLogin) {
      this.login();
      return;
    }
  }
  @action getIAMToken(code) {
    return new Promise((resolve) => {
      getIAMToken({ params: { authorizationCode: code } }).then((res) => {
        if (res.ret === 0) {
          let IAMToken = res.data.accessToken;
          this.saveIamToken(IAMToken);
          this.IAMSwitchUrl = null;
          resolve(IAMToken);
        }
      });
    });
  }
  @action saveIamToken(IAMToken) {
    this.IAMToken = IAMToken;
  }
  @action switchAccount(accountId) {
    this.sharSwitchAccountId = accountId;
    if (store.viewer.hasOpenFile) {
      if (store.appStore.docModified || store.common.docModifiedNoSave) {
        store.saveFileNewStore.setShowSaveDialog(true);
      } else {
        store.saveFileNewStore.saveFile('downFile');
        this.switch();
      }
    } else {
      let origin = location.origin;
      let redirectUrl = encodeURIComponent(`${origin}/login.html`);
      let cb = encodeURIComponent(window.location.href);
      this.IAMSwitchUrl = `https://account.foxitreader.cn/switch?accountId=${accountId}&redirectUrl=${redirectUrl}&cb=${cb}`;
      // window.location.href = this.IAMSwitchUrl
      this.setIsShowIframeSso(true);
    }
  }
  switch = () => {
    let Events = window.UIExtension.PDFViewCtrl.Events;
    window.pdfui.eventEmitter.emit(Events.openFileFailed, null);
    // store.appStore.backToHomeStart('normal');
    store.saveFileNewStore.setShowSaveDialog(false);
    const origin = location.origin;
    const redirectUrl = encodeURIComponent(`${origin}/login.html`);
    const cb = encodeURIComponent(window.location.href);
    const IAMSwitchUrl = `https://account.foxitreader.cn/switch?accountId=${store.loginNewStore.sharSwitchAccountId}&redirectUrl=${redirectUrl}&cb=${cb}`;
    store.loginNewStore.setIAMSwitchUrl(IAMSwitchUrl);
    store.loginNewStore.setIsShowIframeSso(true);
    store.shareCollaborationStore.setShareUserType('');
  };

  jumpLogin() {
    let origin = location.origin;
    let redirectUrl = encodeURIComponent(`${origin}/login.html`);
    let cb = encodeURIComponent(window.location.href);
    let iamLoginUrl = this.IAMSwitchUrl ? this.IAMSwitchUrl : `https://account.foxitreader.cn/login?redirectUrl=${redirectUrl}&cb=${cb}`;
    let cookieArr = ['MD', 'agent', 'version', 'productname', 'UUID'];
    // 解决因网络状态导致IAM加载cookies加载覆盖MD等为0
    const getQueryString = (name) => {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var lower = new RegExp('(^|&)' + name.toLowerCase() + '=([^&]*)(&|$)');
      var upper = new RegExp('(^|&)' + name.toUpperCase() + '=([^&]*)(&|$)');
      var r;
      if (window.location.search.substr(1).match(reg)) {
        r = window.location.search.substr(1).match(reg);
      } else if (window.location.search.substr(1).match(lower)) {
        r = window.location.search.substr(1).match(lower);
      } else {
        r = window.location.search.substr(1).match(upper);
      }
      if (r != null) return unescape(r[2]);
      return 0;
    };
    for (var _i = 0, _d = cookieArr; _i < _d.length; _i++) {
      var cookie = _d[_i];
      var value = getQueryString(cookie) ? getQueryString(cookie) : 0;
      if (value) {
        iamLoginUrl += `&${cookie}=${value}`;
      }
    }

    if (!window.messageListenerAdded) {
      this.event();
      window.messageListenerAdded = true;
    }
    window.open(iamLoginUrl);
  }
  event() {
    window.addEventListener(
      'message',
      (e) => {
        let originName = window.location.origin;
        if (e.origin === originName && e.data && e.data.type === 'IAM') {
          console.log(e.data);
          // e.data为换取的code，使用code换取全局的token（token有效时间 10天）
          // 不存，每次重新登录
          this.getIAMToken(e.data.code).then(() => {
            store.userNewStore.getUserNew();
          });
          this.closeIframeSso();
        }
      },
      false,
    );
  }
}

export default loginNewStore;
